var filterSortBy = "https://shopfront-cdn.tekoapis.com/static/3c8bba9fb4200565.svg";

export { filterSortBy as default };
